module.exports = __webpack_public_path__ + "static/media/31_A.333ac689.png";